import { Divider, Drawer, IconButton, List, ListItem, makeStyles, Link, Collapse, Box, alpha } from "@material-ui/core";
import { Menu, OpenInNew, ExpandMoreOutlined, ExpandLessOutlined } from "@material-ui/icons";
import React, { Fragment, useState } from "react";
import { Link as RouterLink, NavLink } from "react-router-dom";

import navigationConfig from "src/configs/navigations";
// import logo from "src/assets/logo/logo_noel.png";
import logo from "src/assets/logo/logo_blue_white.png";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  menuIconBtn: {
    marginRight: theme.spacing(-1.5),
  },
  sidebarList: {
    minWidth: "250px",
  },
  listItem: {
    textTransform: "capitalize",
    fontWeight: 500,
    cursor: "pointer",
    margin: "0px 8px",
    color: alpha(theme.palette.common.white, 0.65),
  },
  selectListItem: {
    textTransform: "capitalize",
    fontWeight: 500,
    cursor: "pointer",
    margin: "8px 8px",
    color: alpha(theme.palette.common.white, 0.65),
  },
  navLink: {
    padding: "8px 0px",
    color: alpha(theme.palette.common.white, 0.65),
    textDecoration: "none",
    fontSize: "0.9rem",
    cursor: "pointer",
    transition: "color 300ms linear",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
  activeLink: {
    color: theme.palette.primary.main,
  },
  groupItemList: {
    backgroundColor: "#071426",
    "& $navLink": {
      fontSize: "0.8rem",
      lineHeight: 0,
      display: "flex",
      alignItems: "center",
    },
  },
}));

function Sidebar() {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [activeGroupItem, setActiveGroupItem] = useState(undefined);
  const classes = useStyles();

  function toggleSidebar() {
    setOpenSidebar(!openSidebar);
  }

  function handleSidebarClose() {
    setOpenSidebar(false);
    setActiveGroupItem(undefined);
  }

  function toggleGroupItem(groupId) {
    if (activeGroupItem === groupId) {
      setActiveGroupItem(undefined);
    } else {
      setActiveGroupItem(groupId);
    }
  }

  function renderNavItem(item) {
    const AnchorTag = item.externalLink ? Link : NavLink;
    return (
      <AnchorTag
        onClick={handleSidebarClose}
        className={classes.navLink}
        activeClassName={classes.activeLink}
        href={item.externalLink ? item.navLink : undefined}
        target={item.newTab ? "_blank" : undefined}
        to={item.externalLink ? undefined : item.navLink}
      >
        {item.title}
        {item.externalLink && <OpenInNew style={{ marginLeft: 4, fontSize: "inherit" }} />}
      </AnchorTag>
    );
  }

  return (
    <Fragment>
      <IconButton onClick={toggleSidebar} className={classes.menuIconBtn}>
        <Menu fontSize="medium" />
      </IconButton>
      <Drawer anchor="right" open={openSidebar} onClose={handleSidebarClose}>
        <List className={classes.sidebarList}>
          <ListItem onClick={handleSidebarClose}>
            <Link component={RouterLink} to="/">
              <img src={logo} alt="Logo" style={{ height: "36px", verticalAlign: "middle" }} />
            </Link>
          </ListItem>
          <Divider style={{ marginBottom: "16px" }} />
          {navigationConfig.map((item, _) => {
            return item.children ? (
              <Fragment key={item.id}>
                <ListItem onClick={() => toggleGroupItem(item.id)} className={clsx(classes.selectListItem)}>
                  <Box display="flex" alignItem="center">
                    {item.title}{" "}
                    {item.id === activeGroupItem ? (
                      <ExpandLessOutlined fontSize="small" />
                    ) : (
                      <ExpandMoreOutlined fontSize="small" />
                    )}
                  </Box>
                </ListItem>
                <Box px={2}>
                  <Collapse in={item.id === activeGroupItem}>
                    <List className={clsx(classes.groupItemList)}>
                      {item.children.map((cItem) => (
                        <ListItem key={cItem.id} button className={classes.listItem}>
                          {renderNavItem(cItem)}
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </Box>
              </Fragment>
            ) : (
              <ListItem key={item.id} className={classes.listItem}>
                {renderNavItem(item)}
              </ListItem>
            );
          })}
          {/* <ListItem className={classes.listItem}>
            <MarketSelect />
          </ListItem> */}
        </List>
        <Box py={2}></Box>
      </Drawer>
    </Fragment>
  );
}

export default Sidebar;
